"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); //===============
// game action types
//===============

var JOINING_FAILURE = exports.JOINING_FAILURE = "JOINING_FAILURE";
var SET_ROOM_ID = exports.SET_ROOM_ID = "SET_ROOM_ID";
var SET_GAME_STATE = exports.SET_GAME_STATE = "SET_GAME_STATE";
var SETUP_CHALLENGE = exports.SETUP_CHALLENGE = "SETUP_CHALLENGE"; //+Remote Requests+

var REMOTE_REQUEST_RUN_CODE = exports.REMOTE_REQUEST_RUN_CODE = "REMOTE_REQUEST_RUN_CODE";
var REMOTE_REQUEST_SUBMIT_CODE = exports.REMOTE_REQUEST_SUBMIT_CODE = "REMOTE_REQUEST_SUBMIT_CODE";
var REMOTE_REQUEST_SKIP_TASK = exports.REMOTE_REQUEST_SKIP_TASK = "REMOTE_REQUEST_SKIP_TASK";
var REMOTE_REQUEST_NEXT_TASK = exports.REMOTE_REQUEST_NEXT_TASK = "REMOTE_REQUEST_NEXT_TASK"; //+Server Async Actions+
//Running code

var RUN_CODE = exports.RUN_CODE = "RUN_CODE";
var RUN_CODE_REQUEST = exports.RUN_CODE_REQUEST = "RUN_CODE_REQUEST";
var RECEIVE_RUN_CODE_RESULT = exports.RECEIVE_RUN_CODE_RESULT = "RECEIVE_RUN_CODE_RESULT"; //Submitting code

var RECEIVE_SUBMIT_CODE_RESULT = exports.RECEIVE_SUBMIT_CODE_RESULT = "RECEIVE_SUBMIT_CODE_RESULT"; //Skipping a task

var DO_SKIP_TASK = exports.DO_SKIP_TASK = "DO_SKIP_TASK";
var SET_SKELETON_CODE = exports.SET_SKELETON_CODE = "SET_SKELETON_CODE";
var SET_ALL_SKELETON_CODE = exports.SET_ALL_SKELETON_CODE = "SET_ALL_SKELETON_CODE";
var RESET_STATUSES_TO_DEFAULT = exports.RESET_STATUSES_TO_DEFAULT = "RESET_STATUSES_TO_DEFAULT"; // export const RECEIVE_SKIP_TASK_RESULT = 'RECEIVE_SKIP_TASK_RESULT';
//Adding a player

var ADD_PLAYER = exports.ADD_PLAYER = "ADD_PLAYER";
var INVITE_PLAYER = exports.INVITE_PLAYER = "INVITE_PLAYER"; //Removing a player

var REMOVE_PLAYER = exports.REMOVE_PLAYER = "REMOVE_PLAYER"; //player connect/disconnect

var CONNECT_PLAYER = exports.CONNECT_PLAYER = "CONNECT_PLAYER";
var DISCONNECT_PLAYER = exports.DISCONNECT_PLAYER = "DISCONNECT_PLAYER";
var GAME_START = exports.GAME_START = "GAME_START";
var GAME_COMPLETE = exports.GAME_COMPLETE = "GAME_COMPLETE";
var START_COUNTING = exports.START_COUNTING = "START_COUNTING";
var STOP_COUNTING = exports.STOP_COUNTING = "STOP_COUNTING"; //User ActionsTypes

var CODE_CHANGED = exports.CODE_CHANGED = "CODE_CHANGED"; //Show feedback

var FEEDBACK_SUBMITTED = exports.FEEDBACK_SUBMITTED = "FEEDBACK_SUBMITTED"; //button click

var BUTTON_TYPE_CLICKED = exports.BUTTON_TYPE_CLICKED = "BUTTON_TYPE_CLICKED"; //Server ActionsTypes

var SET_ELAPSED = exports.SET_ELAPSED = "SET_ELAPSED";
var SET_PLAYER_STATE = exports.SET_PLAYER_STATE = "SET_PLAYER_STATE";
var SET_PLAYER_ID = exports.SET_PLAYER_ID = "SET_PLAYER_ID";
var SET_PLAYER_EDITOR_INDEX = exports.SET_PLAYER_EDITOR_INDEX = "SET_PLAYER_EDITOR_INDEX";
var SET_CODE = exports.SET_CODE = "SET_CODE";